export default __webpack_public_path__ + "static/media/phone.421da9db.svg";